











import "./goal-filter.less";
import Vue from "vue";
import { mapState } from "vuex";

export default Vue.extend({
  name: "GoalFilter",
  components: {},
  props: {},
  data() {
    return {
      goalId: "",
      hashTagFilter: "All",
      currentGoalId: null
    };
  },
  computed: {
    ...mapState("goal", ["loading", "currentGoal", "myTrackingGoals"]),
    lastSelectedGoalId: {
      get() {
        return (this as any).$store.state.goal.lastSelectedGoalId;
      },
      set(newValue) {
        return (this as any).$store.dispatch("goal/setLastSelectedGoalId", newValue);
      }
    },
    goalOptions(): any {
      let allGoals = this.$store.state.goal.myTrackingGoals || [];
      if (this.hashTagFilter !== "All") {
        allGoals = allGoals.filter(goal => goal.hashTagList && goal.hashTagList.filter(tag => tag.text === this.hashTagFilter).length > 0);
      }

      return allGoals;
    },
    hashTagOptions() {
      let hashTags = ["All"];
      let allGoals = this.$store.state.goal.myTrackingGoals || [];
      allGoals.forEach(goal => {
        hashTags = hashTags.concat(goal.hashTagList.map(tag => tag.text));
      });
      return [...new Set(hashTags)];
    }
  },
  watch: {
    currentGoalId(newValue) {
      let context = this as any;

      context.$store.dispatch("goal/get", { id: newValue }).then(response => {
        this.emitFilter();
      });
      context.currentTrackerId = context.lastSelectedTrackerId || abp.session.userId;

      this.lastSelectedGoalId = newValue;
    },
    goalOptions(newValue) {
      if (newValue.length > 0) {
        if (this.lastSelectedGoalId === null) {
          this.currentGoalId = newValue[0].id;
        } else {
          let goalId = newValue.filter(goal => goal.id == this.lastSelectedGoalId).length === 1 ? this.lastSelectedGoalId : newValue[0].id;
          this.currentGoalId = goalId;
        }
      }
    }
  },
  created() {
    this.$store.dispatch("goal/getMyTrackingGoals").then(() => {});
  },
  methods: {
    emitFilter() {
      let content = this as any;
      this.$emit("filter", { goalId: content.currentGoalId, goal: content.currentGoal });
    }
  }
});
